import { PurchaseOrderDetailsProvider } from './contexts/PurchaseOrderDetailsContext';
import PurchaseOrdersDetailsTop from './components/PurchaseOrderDetailsTop';
import PurchaseOrdersDetailsPopUps from './components/PurchaseOrderDetailsPopUps';
import PurchaseOrdersDetailsMainArea from './components/PurchaseOrderDetailsMainArea';
import PageArea from '../../components/shared/PageArea';
import { Grid } from '@mui/material';

const PurchaseOrdersDetails = () => {
  return <PurchaseOrderDetailsProvider>
    <PageArea>
      <Grid container
        spacing={5}>
        <PurchaseOrdersDetailsTop />
        <PurchaseOrdersDetailsMainArea />
      </Grid>
    </PageArea>
    <PurchaseOrdersDetailsPopUps />
  </PurchaseOrderDetailsProvider>;
};

export default PurchaseOrdersDetails;